import Cookies from "js-cookie";
import { AwsClient } from "aws4fetch";
import authService from "../Auth/AuthenticationService";
import { Config } from "../../Utilities/Config";

type Result<T> = T | Error;

interface Request {
  request: {
    method: string;
    path: string;
    body: any | undefined;
  };
  completion: (result: Result<any>) => void;
}

class APINetworkClient {

  private static _instance: APINetworkClient;

  private requests: Request[] = [];
  private isRunning: boolean;

  private constructor() {
    this.isRunning = false;
  }

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public request(method: string, path: string, body: any | undefined, params: any | undefined, completion: (result: Result<any>) => void) {
    this.requests.push({ request: { method, path, body }, completion });
    this.nextRequest();
  }

  private async nextRequest() {
    if (this.isRunning) return;
    this.isRunning = true;

    const request = this.requests.shift();
    if (!request) {
      this.isRunning = false;
      return;
    }

    const complete = () => {
      this.isRunning = false;
      this.nextRequest();
    };

    try {
      await this.updateCredentials();
      const aws = this.makeClient();
      const url = Config.apiEndpoint() + request.request.path;
      const init: RequestInit = { method: request.request.method };
      if (request.request.body != null) {
        init.body = JSON.stringify(request.request.body);
        init.headers = { 'Content-Type': 'application/json' };
      }
      const response = await aws.fetch(url, init);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const data = await response.json();
      request.completion(data);
    } catch (error) {
      request.completion(error instanceof Error ? error : new Error(String(error)));
    }

    complete();
  }

  private makeClient(): AwsClient {
    const ak = Cookies.get('ak') ?? '';
    const sk = Cookies.get('sk') ?? '';
    const st = Cookies.get('st');
    return new AwsClient({
      accessKeyId: ak,
      secretAccessKey: sk,
      sessionToken: st,
      region: 'eu-west-2',
      service: 'execute-api',
      retries: 3,
    });
  }

  private async updateCredentials() {
    if (!authService.hasCredentials()) {
      await authService.fetchCredentials();
    }
  }
}

const apiNetworkingClient = APINetworkClient.Instance;
export default apiNetworkingClient;
